import type { IUserProfileResponse } from '@montugroup/circuit-shared/types/user';
import { CircularProgress, Typography } from '@montugroup/design-system';
import { Grid2 } from '@mui/material';

interface IProfileContent {
  data: IUserProfileResponse | undefined;
  isLoading: boolean;
  isSuccess: boolean;
}

export const ProfileInfo = ({ data, isLoading, isSuccess }: IProfileContent) => {
  if (isLoading) {
    return <CircularProgress />;
  }
  if (isSuccess && data?.user && data?.patient) {
    const { user, patient } = data;
    return (
      <Grid2 container spacing={6}>
        <Grid2 container size={{ xs: 12 }}>
          {/* Full Name */}
          <Grid2 container size={{ xs: 12, md: 4 }} spacing={2}>
            <Grid2 size={{ xs: 12 }}>
              <Typography variant="body2">Full name</Typography>
            </Grid2>
            <Grid2 size={{ xs: 10 }}>
              <Typography>
                {user.first_name} {user.last_name}
              </Typography>
            </Grid2>
          </Grid2>
          {/* DOB */}
          <Grid2 container size={{ xs: 12, md: 4 }} spacing={2}>
            <Grid2 size={{ xs: 10 }}>
              <Typography variant="body2">Date of birth</Typography>
            </Grid2>
            <Grid2 size={{ xs: 10 }}>
              <Typography>{new Date(patient.dob).toLocaleDateString()}</Typography>
            </Grid2>
          </Grid2>
        </Grid2>
        <Grid2 container size={{ xs: 12 }}>
          {/* Email */}
          <Grid2 container size={{ xs: 12, md: 4 }} spacing={2}>
            <Grid2 size={{ xs: 10 }}>
              <Typography variant="body2">Email</Typography>
            </Grid2>
            <Grid2 size={{ xs: 10 }}>
              <Typography>{user.email}</Typography>
            </Grid2>
          </Grid2>
          {/* Phone */}
          <Grid2 container size={{ xs: 12, md: 4 }} spacing={2}>
            <Grid2 size={{ xs: 10 }}>
              <Typography variant="body2">Phone</Typography>
            </Grid2>
            <Grid2 size={{ xs: 10 }}>
              <Typography>{user.phone}</Typography>
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    );
  }
};
